import { ReactNode } from "react";
const styles = new Proxy({"ResutlsFor":"ResutlsFor-d0651"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const ResultsFor = ({ children = "" }: ResultsForProps) => (
  <h1 className={styles.ResutlsFor}>
    Results for: "<span>{children}</span>"
  </h1>
);

interface ResultsForProps {
  children: ReactNode;
}

export default ResultsFor;
